<template>
   <div class="rent-a-car-card-container" v-if="CarFilters" :class="car.selected ? 'selected-car' : ''">
      <div class="card-main-wrapper">
         <div class="card-basics-mobile-wrapper">
            <span class="car-name">{{ car?.markModel }}</span>
            <span class="or-smiliar">{{ $t("rentacar_orSmiliar") }}</span>
         </div>

         <!-- Card Body Left -->
         <section class="card-photo-wrapper">
            <div class="vehicle-type-badge" v-if="(car?.bodyType ?? 0) != 0">{{ $options.filters.ERacBodyType(car.bodyType) }}</div>
            <img :src="car?.imageUrl" alt="" srcset="" />
         </section>

         <!-- Card Body Middle -->
         <section class="card-informations-wrapper">
            <div>
               <div class="card-basics-wrapper d-none d-md-block">
                  <span class="car-name">{{ car?.markModel }}</span>
                  <!-- <span class="car-features"
                     >/ {{ $options.filters.ERacFuelType(car.fuelType) }} /{{ $options.filters.ERacGearType(car.fuelType) }}</span
                  > -->
                  <span class="or-smiliar">{{ $t("rentacar_orSmiliar") }}</span>

                  <div class="car-body-type-badge" v-if="car.bodyType != 0">{{ $options.filters.ERacBodyType(car.bodyType) }}</div>
               </div>

               <div class="card-extra-features-wrapper d-none d-md-block" @mouseenter="handlerShowExtras(true)" @mouseleave="handlerShowExtras(false)" v-if="car?.facilities.length != 0">
                  <!-- <div class="card-extra-features-wrapper"> -->
                  <button :class="showExtras ? 'active' : ''">{{ $t("rentacar_extraFeatures") }}</button>
                  <!-- {{ car.features }} -->

                  <ul class="card-extra-features-box" v-if="showExtras">
                     <li v-for="(facility, index) in car?.facilities || []" :key="index">
                        {{ facility }}
                     </li>
                     <!-- <li>Airport Surcharge</li>
                     <li>Third Party Liability Insurance (TPL)</li>
                     <li>Unlimited Mileage</li>
                     <li>Collision Damage Waiver</li>
                     <li>Theft Waiver (THW)</li> -->
                  </ul>
               </div>
            </div>
            <div>
               <ul class="car-features" @click="handlerShowAncillaries">
                  <li class="icon-automatic" v-if="isNotNil(car?.gearType)">{{ $options.filters.ERacGearType(car.gearType) }}</li>
                  <li class="icon-fuel" v-if="isNotNil(car?.fuelType)">{{ $options.filters.ERacFuelType(car.fuelType) }}</li>
                  <li class="icon-baggage" v-if="isNotNil(car?.smallBaggageCapacity)">{{ car.smallBaggageCapacity }} {{ $t("rentacar_smallBaggage") }}</li>
                  <li class="icon-suitcases" v-if="isNotNil(car?.largeBaggageCapacity)">{{ car.largeBaggageCapacity }} {{ $t("rentacar_largeBaggage") }}</li>
                  <li class="icon-aircond" v-if="car?.airConditioning === true">{{ $t("rentacar_airConditioning") }}</li>
                  <!-- <li class="icon-aircond" v-else-if="car?.airConditioning === false">{{ $t("rentacar_noAirConditioning") }}</li> -->
                  <li class="icon-passengers" v-if="isNotNil(car?.passengerCapacity)">{{ car.passengerCapacity }} {{ $t("rentacar_passengerCapacity") }}</li>
                  <li class="icon-doors" v-if="isNotNil(car?.doorCount)">{{ car.doorCount }} {{ $t("rentacar_doorCount") }}</li>
               </ul>
            </div>

            <div class="rental-policies-container">
               <div class="rental-policies" v-if="hasVisiblePolicies">
                  <div class="rental-policies__title">{{ $t("rentacar_rentalPolicies") }}</div>

                  <ul>
                     <li class="rental-policies-item" v-if="mileagePolicyLabel">
                        <div class="rental-policies-item__title">{{ $t("rentacar_lblMilleagePolicy") }}</div>
                        <!-- {{ car.fuelPolicyType }} -->
                        <div class="rental-policies-item__description">{{ mileagePolicyLabel }}</div>
                     </li>
                     <li class="rental-policies-item" v-if="isNotNil(car?.deposit)">
                        <div class="rental-policies-item__title">{{ $t("rentacar_lblDeposit") }}</div>
                        <!-- {{ car.fuelPolicyType }} -->
                        <div class="rental-policies-item__description">{{ car.deposit }}</div>
                     </li>
                     <li class="rental-policies-item" v-if="isNotNil(car?.cdwExcess)">
                        <div class="rental-policies-item__title">{{ $t("rentacar_lblCDWExcess") }}</div>
                        <!-- {{ car.fuelPolicyType }} -->
                        <div class="rental-policies-item__description">{{ car.cdwExcess }}</div>
                     </li>
                     <li class="rental-policies-item" v-if="isNotNil(car?.fuelPolicyType) && car.fuelPolicyType != 0">
                        <div class="rental-policies-item__title">{{ $t("rentacar_lblFuelPolicy") }}</div>
                        <div class="rental-policies-item__description">{{ $t("rentacar_lbl" + $options.filters.ERacFuelPolicyType(car.fuelPolicyType)) }}</div>
                     </li>
                  </ul>
               </div>

               <div class="rental-policies mandatory-fees" v-if="mandatoryFees.length">
                  <div class="rental-policies__title">{{ $t("rentacar_mandatoryFeesTitle") }}</div>

                  <ul>
                     <li class="rental-policies-item" v-for="(fee, index) in mandatoryFees" :key="index" :class="{ localPayment: fee.localPayment }">
                        <div class="rental-policies-tem-information-wrapper">
                           <div class="rental-policies-item-name-wrapper">
                              <span class="rental-policies-item-name">{{ fee.displayName }}</span>
                              <span class="rental-policies-item-badge" v-if="fee.localPayment">{{ $t("rentacar_localPayment") }}</span>
                           </div>

                           <span class="rental-policies-item-price">{{ fee.amount | price }}</span>
                        </div>
                     </li>
                  </ul>
               </div>

               <div class="rental-policies driver-requirements">
                  <div class="rental-policies__title">{{ $t("rentacar_DriverRequirements") }}</div>

                  <ul>
                     <li class="rental-policies-item" v-if="isNotNil(car?.minLicenseAge)">
                        <div class="rental-policies-item__title">{{ $t("rentacar_lblMinLicenseAge") }}</div>

                        <div class="rental-policies-item__description">{{ car.minLicenseAge }} {{ $t("rentacar_lblyears") }}</div>
                     </li>
                     <li class="rental-policies-item" v-if="isNotNil(car?.minDriverAge) && car?.minDriverAge != 0">
                        <div class="rental-policies-item__title">{{ $t("rentacar_lblMinDriverAge") }}</div>

                        <div class="rental-policies-item__description">{{ car.minDriverAge }} {{ $t("rentacar_lblage") }}</div>
                     </li>
                     <li class="rental-policies-item" v-if="isNotNil(car?.maxDriverAge) && car?.maxDriverAge != 0">
                        <div class="rental-policies-item__title">{{ $t("rentacar_lblMaxDriverAge") }}</div>

                        <div class="rental-policies-item__description">{{ car.maxDriverAge }} {{ $t("rentacar_lblage") }}</div>
                     </li>
                  </ul>
               </div>
            </div>
         </section>

         <!-- Card Body Right -->
         <section class="card-price-wrapper">
            <!-- <div class="provider-badge">
               <span> {{ $t("transfer_lblProvider") }} </span>
            </div> -->
            <!-- <div class="provider-logo rent-a-car">
               <img :src="`/assets/logo_provider/${car.implementationType}.png`" alt="Provider Logo" />
            </div> -->
            <div class="provider-logo rent-a-car" v-if="supplier.logo">
               <img :src="supplier.logo" alt="Provider Logo" />
            </div>
            <div class="provider-badge" v-else>
               <span> {{ supplier.name }} </span>
            </div>
            <div>
               <span class="price-total" v-if="isNotNil(car?.totalPrice)">{{ car.totalPrice | price(currency) }}</span>
               <span class="price-per-day" v-if="isNotNil(car?.pricePerDay)">{{ car.pricePerDay | price(currency) }} / {{ $t("rentacar_lblPerDay") }}</span>
               <!-- <span class="price-per-day">43,00 € / Per day</span> -->
               <!-- {{ selected }}
               {{ showAncillaries }}
               {{ interacted }} -->

               <button @click="handlerSelectCar" :class="car.selected ? 'selected-car-btn' : ''">
                  <!-- <span class="g-radial-loader"></span> -->
                  <span class="g-radial-loader" v-if="waitingForResponse"></span>
                  <span v-else> {{ $t("rentacar_btnSubmit") }}</span>
               </button>

               <!-- <template v-if="car.selected">
                  <button class="cancel" @click="handlerDeselectCar">{{ $t("rentacar_btnCancel") }}</button>
               </template>
               <template v-else>
                  <button @click="handlerSelectCar">{{ $t("rentacar_btnSubmit") }}</button>
               </template> -->

               <!-- <button @click="handlerSelectCar" :class="selected ? 'cancel' : ''">
                  <template v-if="selected"> {{ $t("rentacar_btnCancel") }} </template>
                  <template v-else> {{ $t("rentacar_btnSubmit") }} </template>
               </button> -->

               <span class="show-ancillaries" @click="handlerShowAncillaries" :class="!car.selected ? 'visible' : 'invisible'"> {{ $t("rentacar_lblShowAncillaries") }}</span>
            </div>
         </section>
      </div>

      <!-- <RentACarAncillaries v-if="showAncillaries" @click.native="interacted = true" :ancillaries="ancillaries" /> -->

      <RentACarAncillaries
         show-tabs
         v-if="car.selected || car.showAncillaries"
         @click.native="interacted = true"
         :passengerCapacity="car.passengerCapacity"
         :ancillaries="ancillaries"
         :providerName="car.implementationType == 301 ? 'pandora' : 'cizgi'"
         @requestModel="handlerRequestModel" />

      <div class="card-footer-wrapper" v-if="false">
         <ul>
            <li>
               <i class="min-licence"></i>

               <span>{{ handlerMinLicenseAgeFMT(car.minLicenseAge) }}</span>
            </li>
            <li>
               <i class="min-driver-age"></i>
               <span>{{ handlerMinDriverAgeFMT(car.minDriverAge) }}</span>
            </li>
         </ul>
      </div>
      <RentACarCardDebugger :infos="infos" v-if="showDebugger" />
   </div>
</template>

<script>
import RentACarAncillaries from "@/components/structural/rentacar/search/RentACarAncillaries.vue";
import RentACarCardDebugger from "@/components/structural/rentacar/search/RentACarCardDebugger.vue";
// import { ancillaryType, ancillaryGenerator, ancillaryRequestModelGenerator2 } from "@/helper/rentacar.js";
import { rentacarService } from "@/service/index.js";
export default {
   name: "RentACarCard",
   props: {
      car: Object,
      searchUuid: String,
      currency: String,
      supplier: Object,
      showDebugger: {
         type: Boolean,
         default: false,
      },
   },
   components: {
      RentACarAncillaries,
      RentACarCardDebugger,
   },
   data() {
      return {
         showExtras: false,
         waitingForResponse: false,
         ancillaries: {},
         interacted: false,
         infos: null,
         query: {
            searchUuid: this.searchUuid,
            vehicleUuid: this.car?.vehicleUuid ?? null,
            ancillaries: {},
         },
      };
   },
   computed: {
      CarFilters() {
         try {
            const filters = this.$parent?.$parent?.filters;
            if (!filters || !this.car || !this.supplier) {
               return true;
            }

            const supplierType = filters?.supplier?.[this.supplier.name];
            const vehicleType = filters?.vehicleType?.[this.$options.filters.ERacBodyType(this.car.bodyType)];
            const fuelType = filters?.fuelType?.[this.$options.filters.ERacFuelType(this.car.fuelType)];
            const transmissionType = filters?.transmissionType?.[this.$options.filters.ERacGearType(this.car.gearType)];
            const passengerCapacity = filters?.passengerCapacity?.[this.$options.filters.ERacPassengerCapacity(this.car.passengerCapacity)];

            const checks = [supplierType, vehicleType, fuelType, transmissionType, passengerCapacity].filter((x) => x != null).map((x) => x.checked);

            return checks.length ? checks.every(Boolean) : true;
         } catch (e) {
            return true;
         }
      },
      mileagePolicyLabel() {
         if (!this.car) return null;
         if (this.isNotNil(this.car.mileagePolicy)) return this.car.mileagePolicy;
         if (this.car.mileagePolicy == null && this.car.unlimitedMileage === true) return this.$t("ERacFacilityType_UNLIMITED_MILEAGE");
         return null;
      },
      mandatoryFees() {
         const fees = this.car?.otherFees || [];

         return fees
            .filter((fee) => fee.mandatory)
            .map((fee) => ({
               displayName: fee.name || this.$t("enum_unknown"),
               amount: fee.rentalPrice ?? null,
               badgeText: null,
               badgeClass: null,
               isMandatory: true,
               localPayment: fee.paymentTimingType === 2,
            }));
      },
      hasVisiblePolicies() {
         return this.mileagePolicyLabel || this.isNotNil(this.car?.deposit) || this.isNotNil(this.car?.cdwExcess) || (this.isNotNil(this.car?.fuelPolicyType) && this.car.fuelPolicyType != 0);
      },
   },
   created() {
      const self = this;
      rentacarService;
      // ancillaryType;

      self.infos = {
         ...self.car,
         searchUuid: self.searchUuid,
      };
   },
   methods: {
      isNotNil(val) {
         return val !== null && val !== undefined && val !== "";
      },
      handlerMinDriverAgeFMT(val) {
         return this.$t("rentacarCard_minDriverAge").replace("#VALUE#", val);
      },
      handlerMinLicenseAgeFMT(val) {
         return this.$t("rentacarCard_minLicenseAge").replace("#VALUE#", val);
      },
      handlerRequestModel(ancillaries) {
         this.query.ancillaries = ancillaries;
         this.handlerUpdateCar();
      },
      handlerSelectCar() {
         if (!this.car.selected) {
            this.waitingForResponse = true;
            rentacarService.rentacarSelect(this.query).then((response) => {
               this.$parent.$parent.selection = response;
               this.waitingForResponse = false;
               this.$emit("selection", this.car.vehicleUuid);
            });
            this.handlerGetAncillaries();
         }
      },
      handlerUpdateCar() {
         this.$store.commit("app/setIsProgressGifActive", true);
         rentacarService.rentacarSelect(this.query).then((response) => {
            this.$parent.$parent.selection = response;
            this.$store.commit("app/setIsProgressGifActive", false);
         });
      },
      handlerDeselectCar() {
         this.car.showAncillaries = false;

         const query = {
            searchUuid: this.searchUuid,
            vehicleUuid: null,
            ancillaries: null,
         };

         rentacarService.rentacarSelect(query).then((response) => {
            response;
            this.$parent.$parent.selection = null;
         });
      },
      handlerGetAncillaries() {
         this.$store.commit("app/setIsProgressGifActive", true);
         rentacarService.rentacarAncillaries(this.query).then((response) => {
            this.ancillaries = response.ancillaries;
            this.$store.commit("app/setIsProgressGifActive", false);
         });
      },
      handlerShowAncillaries() {
         this.car.showAncillaries = !this.car.showAncillaries;
         this.handlerGetAncillaries();
         // if (!this.showAncillaries) {
         //    this.interacted = false;
         // }
      },
      handlerShowExtras(status) {
         this.showExtras = status;
      },
   },
   // watch: {
   //    "car.selected": {
   //       handler: function () {
   //          if (this.car.selected == false) {
   //          }
   //       },
   //    },
   // },
};
</script>

<style lang="scss">
.rental-policies-item-badge {
   max-width: fit-content;
}
.rental-policies-container {
   margin-top: 1.5rem;
   display: flex;
   flex-direction: column;
}

.rental-policies {
   flex-direction: column;
   margin-bottom: 1rem;

   &__title {
      font-weight: 500;
      margin-bottom: 0.5rem;
      font-size: var(--normal);
      color: var(--gray-800);
   }

   ul {
      display: flex;
      gap: 1rem;
      .rental-policies-item {
         // border: 1px solid var(--gray-400);
         background-color: #f1f5f9;
         border-radius: 0.75rem;
         padding: 1rem 1rem;
         width: fit-content;
         line-height: 1.35rem;

         &__title {
            font-size: var(--small);
            color: var(--gray-700);
         }
         &__description {
            font-weight: 600;
         }
      }
   }
}

.mandatory-fees {
   ul {
      li {
         display: flex;
         gap: 1rem;
         border: none !important;
         color: #155dfc;
         align-items: flex-start;

         .rental-policies-tem-information-wrapper {
            display: flex;
            flex-direction: column;

            .rental-policies-item-name-wrapper {
               display: flex;
               gap: 0.75rem;

               .rental-policies-item-name {
                  font-weight: 500;
               }
               .rental-policies-item-badge {
                  background-color: #ff6900;
                  color: white;
                  padding: 0 0.5rem;
                  border-radius: 0.25rem;
                  font-size: var(--small);
                  font-weight: 600;
               }
            }
         }

         .rental-policies-item-price {
            font-weight: 800;
         }

         &.isMandatory {
            background-color: #eff6ff;
         }

         &.localPayment {
            background-color: #fff7ed;
            color: #f54900;
         }
      }
   }
}

.driver-requirements {
   margin-bottom: 0 !important;
   margin-top: 0;

   ul {
      li {
         display: flex;
         flex-direction: column;
         gap: 0.5rem;
         line-height: 0.75rem !important;
         border: none !important;
         // border-radius: 0.75rem !important;
         background-color: #eef2ff;
      }
   }
}
</style>

<style lang="scss" scoped>
.rent-a-car-card-container {
   background: var(--gray-50);
   border: 1px solid var(--gray-200);

   border-radius: 1rem;
   /* box-shadow: var(--gray-1000-alpha-75) 0px 4px 6px -1px, var(--gray-1000-alpha-75) 0px 2px 4px -1px; */
   box-shadow: var(--gts-box-shadow);
   display: flex;
   flex-direction: column;
   position: relative;
   margin-bottom: 1.25rem;

   &.selected-car {
      border: 2px solid var(--product-rentacar);
   }

   .card-main-wrapper {
      display: flex;

      @media (max-width: 576px) {
         flex-direction: column;
      }

      .card-basics-mobile-wrapper {
         display: none;

         padding-left: 1rem;
         margin-top: 2rem;
         align-items: baseline;

         @media (max-width: 576px) {
            display: flex;
         }

         span.car-name {
            font-size: var(--large);
            font-weight: 800;
         }
         span.or-smiliar {
            font-size: 0.85rem;
            text-decoration: underline;
            margin-left: 0.5rem;
         }
      }
      section {
         width: auto;
         padding: 1.5rem;
         &.card-photo-wrapper {
            border-right: 1px solid var(--gray-300);
            padding: 0 1rem !important;
            align-content: flex-start;
            .vehicle-type-badge {
               background-color: var(--gray-400);
               //color: var(--gray-50);
               color: var(--txt-white);
               position: absolute;
               font-size: 0.85rem;
               font-weight: 600;
               padding: 0.125rem 1rem;
               border-bottom-right-radius: 1rem;
               border-top-left-radius: 1rem;
               left: 0;
               top: 0;
            }
            img {
               width: 500px;
               height: auto;
            }
         }
         &.card-informations-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            @media (max-width: 576px) {
               padding: 0.75rem;
            }
            div {
               display: flex;
               justify-content: space-between;

               .card-basics-wrapper {
                  display: flex !important;

                  align-items: center;
                  span {
                     color: var(--gray-800);
                     margin-right: 0.5rem;
                     &.car-name {
                        font-size: var(--xlarge);
                        font-weight: 800;
                     }
                     &.car-features {
                        font-weight: 600;
                     }
                     &.or-smiliar {
                        font-size: 0.85rem;
                        text-decoration: underline;
                     }
                  }

                  .car-body-type-badge {
                     background-color: #cbfbf1;
                     color: #009689;
                     padding: 0.25rem 0.5rem;
                     border-radius: 0.5rem;
                     font-size: 14px;
                     font-weight: 500;
                  }
               }

               .card-extra-features-wrapper {
                  position: relative;
                  button {
                     background-color: var(--gray-200);
                     color: var(--gray-800);
                     border-radius: 24rem;
                     padding: 0rem 1rem;
                     font-weight: 600;
                     font-size: 0.85rem;

                     &:hover,
                     &.active {
                        background-color: var(--gray-800);
                        //color: var(--gray-50);
                        color: var(--gray-0);
                     }
                  }
                  .card-extra-features-box {
                     position: absolute;
                     background: var(--gray-50);
                     border: 1px solid var(--gray-300);
                     /* box-shadow: var(--gray-1000-alpha-75) 0px 4px 6px -1px, var(--gray-1000-alpha-75) 0px 2px 4px -1px; */
                     box-shadow: var(--gts-box-shadow);
                     padding: 1rem 1.5rem;
                     top: 100%;
                     left: -500px;
                     right: -500px;
                     margin: auto;
                     width: fit-content;
                     z-index: 10;
                     border-radius: 1rem;

                     li {
                        white-space: nowrap;
                        padding: 0.25rem 0;
                        font-weight: 500;
                     }
                  }
               }

               ul.car-features {
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  cursor: pointer;

                  width: 100%;

                  @media (max-width: 576px) {
                     grid-template-columns: repeat(2, 1fr);
                  }

                  li {
                     margin: 0.5rem;
                     padding: 0.125rem 0.5rem;
                     background-repeat: no-repeat;
                     text-indent: 1.25rem;
                     white-space: nowrap;
                     font-size: var(--small);
                     background-position-y: center;

                     &.icon {
                        &-automatic {
                           background-image: url("data:image/svg+xml;base64,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");
                        }
                        &-suitcases {
                           background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS43NDMiIGhlaWdodD0iMjQuNzg5IiB2aWV3Qm94PSIwIDAgMTUuNzQzIDI0Ljc4OSI+CiAgPGcgaWQ9Ikdyb3VwXzExNTU2IiBkYXRhLW5hbWU9Ikdyb3VwIDExNTU2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzQ1LjYzOSAtMTgxLjIyOSkiPgogICAgPGcgaWQ9IkJhZ2dhZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc0NS42MzkgMTgxLjIyOSkiPgogICAgICA8cGF0aCBpZD0iRWxsaXBzZV8xNTYiIGRhdGEtbmFtZT0iRWxsaXBzZSAxNTYiIGQ9Ik0yLjI3NC0uNzVBMy4wMjQsMy4wMjQsMCwxLDEtLjc1LDIuMjc0LDMuMDI4LDMuMDI4LDAsMCwxLDIuMjc0LS43NVptMCw0LjUyNGExLjUsMS41LDAsMSwwLTEuNS0xLjVBMS41LDEuNSwwLDAsMCwyLjI3NCwzLjc3NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMDkzIDE5LjQ5KSIgZmlsbD0iIzRiNGI0YiIvPgogICAgICA8cGF0aCBpZD0iRWxsaXBzZV8xNTgiIGRhdGEtbmFtZT0iRWxsaXBzZSAxNTgiIGQ9Ik0yLjIyNi0uNzVBMi45NzYsMi45NzYsMCwxLDEtLjc1LDIuMjI2LDIuOTc5LDIuOTc5LDAsMCwxLDIuMjI2LS43NVptMCw0LjQyN0ExLjQ1MSwxLjQ1MSwwLDEsMCwuNzc1LDIuMjI2LDEuNDUyLDEuNDUyLDAsMCwwLDIuMjI2LDMuNjc3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS42MDMgMTkuNTYzKSIgZmlsbD0iIzRiNGI0YiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85ODgwIiBkYXRhLW5hbWU9IlBhdGggOTg4MCIgZD0iTTkuMDI4LjI1aDIuNTg1YTIuNywyLjcsMCwwLDEsMi43LDIuN1Y1LjAwNkg2LjMyN1YyLjk1MUEyLjcsMi43LDAsMCwxLDkuMDI4LjI1Wm0zLjc2MSwzLjIzMXYtLjUzYTEuMTc3LDEuMTc3LDAsMCwwLTEuMTc2LTEuMTc2SDkuMDI4QTEuMTc3LDEuMTc3LDAsMCwwLDcuODUyLDIuOTUxdi41M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjM5OSAtMC4yNSkiIGZpbGw9IiM0YjRiNGIiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTg4MSIgZGF0YS1uYW1lPSJQYXRoIDk4ODEiIGQ9Ik04LjIsMTMuNDg0QTIyLjU0NCwyMi41NDQsMCwwLDEsLjgzMywxMi4yNDFsLjUtMS40NDJBMjEuMDMyLDIxLjAzMiwwLDAsMCw4LjIsMTEuOTU5YTIwLjk4NSwyMC45ODUsMCwwLDAsNi44NTMtMS4xNmwuNSwxLjQ0MkEyMi41MDgsMjIuNTA4LDAsMCwxLDguMiwxMy40ODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4yNjcgLTMuOTY3KSIgZmlsbD0iIzRiNGI0YiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85ODgyIiBkYXRhLW5hbWU9IlBhdGggOTg4MiIgZD0iTTguMTg5LDE5LjQ4NEEyMi41NDUsMjIuNTQ1LDAsMCwxLC44MzMsMTguMjQxbC41LTEuNDQyYTIwLjg3NiwyMC44NzYsMCwwLDAsMTMuNzIsMGwuNSwxLjQ0MkEyMi41NDUsMjIuNTQ1LDAsMCwxLDguMTg5LDE5LjQ4NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjI2NyAtNS4xMzQpIiBmaWxsPSIjNGI0YjRiIi8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk4ODQiIGRhdGEtbmFtZT0iUGF0aCA5ODg0IiBkPSJNMTIuNzg5LDM0Ljc2NUg5LjgyNFYzMy4yMzloMi45NjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMy4zNTggLTEyLjU2NykiIGZpbGw9IiM0YjRiNGIiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTg4NSIgZGF0YS1uYW1lPSJQYXRoIDk4ODUiIGQ9Ik0yLjYyOSwyNS4xMjRhMy4xNTksMy4xNTksMCwwLDEtMi4zOC0zLjA4MlY5LjQyNUEzLjE1NywzLjE1NywwLDAsMSwzLjM4LDYuMjVoOS40NzhhMy4xNTcsMy4xNTcsMCwwLDEsMy4xMzIsMy4xNzVWMjIuMDQyYTMuMTU3LDMuMTU3LDAsMCwxLTIuMiwzLjAzbC0uNDYxLTEuNDU0YTEuNjM3LDEuNjM3LDAsMCwwLDEuMTMyLTEuNTc2VjkuNDI1YTEuNjMsMS42MywwLDAsMC0xLjYwNy0xLjY1SDMuMzhhMS42MywxLjYzLDAsMCwwLTEuNjA3LDEuNjVWMjIuMDQyQTEuNjM2LDEuNjM2LDAsMCwwLDMsMjMuNjQ0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMjQ4IC0zLjAxOSkiIGZpbGw9IiM0YjRiNGIiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=");
                        }
                        &-baggage {
                           background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIyIDIwIj4KICA8ZyBpZD0iR3JvdXBfMTE2MzkiIGRhdGEtbmFtZT0iR3JvdXAgMTE2MzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQxMjEgNTgwMS45ODUpIj4KICAgIDxnIGlkPSJHcm91cF8xMTYzOCIgZGF0YS1uYW1lPSJHcm91cCAxMTYzOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxMjEgLTU4MDAuOTg0KSI+CiAgICAgIDxnIGlkPSJSZWN0YW5nbGVfNDQ3OCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDQ3OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzYzNjM2IiBzdHJva2Utd2lkdGg9IjEuNCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjIyIiBoZWlnaHQ9IjE3IiByeD0iMyIgc3Ryb2tlPSJub25lIi8+CiAgICAgICAgPHJlY3QgeD0iMC43IiB5PSIwLjciIHdpZHRoPSIyMC42IiBoZWlnaHQ9IjE1LjYiIHJ4PSIyLjMiIGZpbGw9Im5vbmUiLz4KICAgICAgPC9nPgogICAgICA8ZyBpZD0iUmVjdGFuZ2xlXzQ0NzkiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDQ0NzkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcgLTEpIiBmaWxsPSJub25lIiBzdHJva2U9IiMzNjM2MzYiIHN0cm9rZS13aWR0aD0iMS40Ij4KICAgICAgICA8cGF0aCBkPSJNMiwwSDZBMiwyLDAsMCwxLDgsMlY0QTAsMCwwLDAsMSw4LDRIMEEwLDAsMCwwLDEsMCw0VjJBMiwyLDAsMCwxLDIsMFoiIHN0cm9rZT0ibm9uZSIvPgogICAgICAgIDxwYXRoIGQ9Ik0yLC43SDZBMS4zLDEuMywwLDAsMSw3LjMsMlYzLjNhMCwwLDAsMCwxLDAsMEguN2EwLDAsMCwwLDEsMCwwVjJBMS4zLDEuMywwLDAsMSwyLC43WiIgZmlsbD0ibm9uZSIvPgogICAgICA8L2c+CiAgICAgIDxnIGlkPSJSZWN0YW5nbGVfNDQ4MCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDQ4MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNSAyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzYzNjM2IiBzdHJva2Utd2lkdGg9IjEuNCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjEzIiBoZWlnaHQ9IjE3IiBzdHJva2U9Im5vbmUiLz4KICAgICAgICA8cmVjdCB4PSIwLjciIHk9IjAuNyIgd2lkdGg9IjExLjYiIGhlaWdodD0iMTUuNiIgZmlsbD0ibm9uZSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K");
                        }
                        &-aircond {
                           background-image: url("data:image/svg+xml;base64,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");
                        }
                        &-passengers {
                           background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNy45NTEiIHZpZXdCb3g9IjAgMCAyNCAxNy45NTEiPgogIDxnIGlkPSJpY29uLWFjdGl2ZS1hZ2VudHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNC4zMjcgLTMwLjcxNCkiPgogICAgPHBhdGggaWQ9IkVsbGlwc2VfMTI2OSIgZGF0YS1uYW1lPSJFbGxpcHNlIDEyNjkiIGQ9Ik0zLjg3My0uNzVBNC42MjMsNC42MjMsMCwxLDEtLjc1LDMuODczLDQuNjI4LDQuNjI4LDAsMCwxLDMuODczLS43NVptMCw3Ljk3M2EzLjM1LDMuMzUsMCwxLDAtMy4zNS0zLjM1QTMuMzU0LDMuMzU0LDAsMCwwLDMuODczLDcuMjIzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzguMzQ5IDMxLjQ2NCkiIGZpbGw9IiMzNDM0MzQiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwMzQ0IiBkYXRhLW5hbWU9IlBhdGggMTAzNDQiIGQ9Ik01MC4xMTgsNTIuMjg3SDQ4Ljg0NWE2LjYyNCw2LjYyNCwwLDEsMC0xMy4yNDUsMEgzNC4zMjdhNy45LDcuOSwwLDEsMSwxNS43OTEsMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTMuNjIyKSIgZmlsbD0iIzM0MzQzNCIvPgogICAgPHBhdGggaWQ9IkVsbGlwc2VfMTI3MSIgZGF0YS1uYW1lPSJFbGxpcHNlIDEyNzEiIGQ9Ik0zLjE0MS0uNzVBMy44OTEsMy44OTEsMCwxLDEtLjc1LDMuMTQxLDMuOSwzLjksMCwwLDEsMy4xNDEtLjc1Wm0wLDYuNTA5QTIuNjE4LDIuNjE4LDAsMSwwLC41MjMsMy4xNDEsMi42MjEsMi42MjEsMCwwLDAsMy4xNDEsNS43NTlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0OC42MjQgMzIuMTk2KSIgZmlsbD0iIzM0MzQzNCIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTAzNDYiIGRhdGEtbmFtZT0iUGF0aCAxMDM0NiIgZD0iTTYyLjY5Myw0OS45NzVINjEuNDIxYTUuNDI1LDUuNDI1LDAsMCwwLTEuNjQyLTMuOTE5LDUuMiw1LjIsMCwwLDAtMy42NDctMS40OTMsNS4wMTQsNS4wMTQsMCwwLDAtMi44NjQuODZsLS4wMDYsMGE1Ljc0Niw1Ljc0NiwwLDAsMC0xLjUxMywxLjUxN2wtMS4wNjEtLjdBNy4wMjcsNy4wMjcsMCwwLDEsNTIuNTA5LDQ0LjRhNi4yNTUsNi4yNTUsMCwwLDEsMy42MjItMS4xMSw2LjQ3LDYuNDcsMCwwLDEsNC41MzYsMS44NTRBNi42ODgsNi42ODgsMCwwLDEsNjIuNjkzLDQ5Ljk3NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00LjM2NyAtMy4zNjgpIiBmaWxsPSIjMzQzNDM0Ii8+CiAgPC9nPgo8L3N2Zz4K");
                        }
                        &-fuel {
                           background-image: url("data:image/svg+xml;base64,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");
                        }
                        &-doors {
                           background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxOS44MTMiIHZpZXdCb3g9IjAgMCAyMCAxOS44MTMiPgogIDxnIGlkPSJHcm91cF8xMTU1OCIgZGF0YS1uYW1lPSJHcm91cCAxMTU1OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc0NCAtMjYxLjE3OCkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTA5NTMiIGRhdGEtbmFtZT0iUGF0aCAxMDk1MyIgZD0iTTEwLjE2OCwxLjExN2ExNy4zNjgsMTcuMzY4LDAsMCwwLTMuNDgzLjMyN2MtLjczOS4xNTItMS4zNjUuMjYzLTEuOTE4LjM2MUE3LjU2OSw3LjU2OSwwLDAsMC0uMzQsNC4yOTRDLTIuNDIsNi4yMTEtMy42LDkuNTI4LTQuMDA4LDEwLjg0M2wzLjY5MSw2LjkyOUgxMi43MTlWMS4yNjFhMjMuMSwyMy4xLDAsMCwwLTIuNTUxLS4xNDRtMC0xLjU3OUEyMy4xMTcsMjMuMTE3LDAsMCwxLDE0LjMtLjFWMTkuMzUxSC0xLjI2NUwtNS43LDExLjAyMnMxLjI3NC01LjEwOCw0LjI5Mi03Ljg4OVMyLjQzOS43MDYsNi4zNjYtLjFBMTkuMDMxLDE5LjAzMSwwLDAsMSwxMC4xNjgtLjQ2MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc0OS43MDIgMjYxLjY0KSIgZmlsbD0iIzM0MzQzNCIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTA5NTQiIGRhdGEtbmFtZT0iUGF0aCAxMDk1NCIgZD0iTTEuNzYxLDEuNTc5QTguMjc3LDguMjc3LDAsMCwwLTIuMTM0LDMuMjI2LDYuNDExLDYuNDExLDAsMCwwLTMuNDgxLDUuMkg0LjkwOFYxLjU3OUgxLjc2MU0xLjY1MywwSDYuNDg3VjYuNzhILTUuN0ExMC4zNTcsMTAuMzU3LDAsMCwxLTMuMiwyLjA2NSwxMC4wMDUsMTAuMDA1LDAsMCwxLDEuNjUzLDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NTQuNSAyNjQuNDY4KSIgZmlsbD0iIzM0MzQzNCIvPgogICAgPHBhdGggaWQ9IkxpbmVfNDgzIiBkYXRhLW5hbWU9IkxpbmUgNDgzIiBkPSJNMy4xNTIuODI5SC4wMzlhLjc4OS43ODksMCwwLDEsMC0xLjU3OUgzLjE1MmEuNzg5Ljc4OSwwLDAsMSwwLDEuNTc5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzU2LjYzNyAyNzMuOTQ4KSIgZmlsbD0iIzM0MzQzNCIvPgogIDwvZz4KPC9zdmc+Cg==");
                        }
                     }
                  }
               }
            }
         }
         &.card-price-wrapper {
            border-left: 1px solid var(--gray-300);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            @media (max-width: 576px) {
               background: var(--gray-100);
               margin: 0.5rem;
               padding: 1rem;
               border: none !important;
            }

            .provider-logo img {
               width: 50%;
               min-width: 120px;
               border-radius: 0.5rem;
               overflow: hidden;
               // height: 40px;
               // height: 80%;
            }

            div {
               display: flex;
               flex-direction: column;
               align-items: center;

               // height: 100%;

               span {
                  white-space: nowrap;
                  &.price-total {
                     font-size: var(--xxlarge);
                     font-weight: 800;
                  }
                  &.price-per-day {
                     font-size: 0.85;
                     font-weight: 500;
                     opacity: 0.5;
                  }

                  &.show-ancillaries {
                     font-size: var(--small);
                     font-weight: 500;
                     text-decoration: underline;
                     margin-top: 0.5rem;
                     opacity: 0.7;
                     cursor: pointer;
                  }
               }
               button {
                  background-color: var(--product-rentacar);
                  white-space: nowrap;
                  font-weight: 600;
                  //color: var(--gray-50);
                  color: var(--gray-0);
                  padding: 0.75rem 1rem;
                  border-radius: 0.5rem;
                  margin-top: 0.75rem;
                  min-width: 86px;
                  height: 48px;

                  @media (max-width: 576px) {
                     min-width: 60%;
                  }

                  &.cancel {
                     background-color: var(--gray-400);
                     &:hover {
                        background-color: var(--gray-800);
                     }
                  }

                  &:hover {
                     background-color: var(--teal-700);
                     background-color: var(--accent-primary);
                  }

                  &.selected-car-btn {
                     background-color: var(--gray-800);
                  }
               }
            }
         }
      }
   }
   .card-footer-wrapper {
      display: flex;
      align-items: center;
      background-color: var(--gray-100);
      min-height: 42px;
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;

      ul {
         display: flex;
         align-items: center;
         height: 100%;
         margin-left: 1.5rem;

         li {
            display: flex;
            align-items: center;
            margin-right: 1.5rem;

            i {
               background-repeat: no-repeat;
               background-position: center center;
               background-size: contain;
               width: 18px;
               height: 18px;
               display: block;
               opacity: 0.95;
               margin-right: 0.25rem;

               &.min-licence {
                  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4xNTgiIGhlaWdodD0iMTcuMjg1IiB2aWV3Qm94PSIwIDAgMTYuMTU4IDE3LjI4NSI+CiAgPGcgaWQ9Ikdyb3VwXzExNjY1IiBkYXRhLW5hbWU9Ikdyb3VwIDExNjY1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi44OTMgLTIuMjUpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzExMDc0IiBkYXRhLW5hbWU9IlBhdGggMTEwNzQiIGQ9Ik0xMC45NzIsMTVhOC41NDEsOC41NDEsMCwwLDAtNi44MjYsMy40MjVjLS4zMzkuNDQ4LS41MDguNjcyLS41Ljk3NWEuOTc4Ljk3OCwwLDAsMCwuMzM1LjY3NGMuMjM4LjE4Ny41NjkuMTg3LDEuMjI5LjE4N0gxNi43MzZjLjY2MSwwLC45OTEsMCwxLjIyOS0uMTg3QS45NzguOTc4LDAsMCwwLDE4LjMsMTkuNGMuMDA2LS4zLS4xNjQtLjUyNy0uNS0uOTc1QTguNTQxLDguNTQxLDAsMCwwLDEwLjk3MiwxNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTEuNDc2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNGQ0ZDRkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF8xMTA3NSIgZGF0YS1uYW1lPSJQYXRoIDExMDc1IiBkPSJNMTEuNDQ2LDEwLjg5M0EzLjk0NiwzLjk0NiwwLDEsMCw3LjUsNi45NDYsMy45NDYsMy45NDYsMCwwLDAsMTEuNDQ2LDEwLjg5M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjQ3NSAwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNGQ0ZDRkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgPC9nPgo8L3N2Zz4K");
               }
               &.min-driver-age {
                  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS42NTMiIGhlaWdodD0iMTcuNzg1IiB2aWV3Qm94PSIwIDAgMTUuNjUzIDE3Ljc4NSI+CiAgPHBhdGggaWQ9IlBhdGhfMTEwNzMiIGRhdGEtbmFtZT0iUGF0aCAxMTA3MyIgZD0iTTE3LjAyOCwxMC41NVY1LjkwOGE2LjA2OCw2LjA2OCwwLDAsMC0uMjY2LTIuNTc1LDIuNDQzLDIuNDQzLDAsMCwwLTEuMDY4LTEuMDY4QTYuMDY5LDYuMDY5LDAsMCwwLDEzLjEyLDJINy45MDhhNi4wNjksNi4wNjksMCwwLDAtMi41NzUuMjY2QTIuNDQzLDIuNDQzLDAsMCwwLDQuMjY2LDMuMzM0LDYuMDY5LDYuMDY5LDAsMCwwLDQsNS45MDh2OC40NjhhNi4wNjksNi4wNjksMCwwLDAsLjI2NiwyLjU3NSwyLjQ0MywyLjQ0MywwLDAsMCwxLjA2OCwxLjA2OCw2LjA2OCw2LjA2OCwwLDAsMCwyLjU3NS4yNjZoMi42MDZtMy4yNTctOC45NTdINy4yNTdtNi41MTQsMy4yNTdINy4yNTdtNi41MTQtNi41MTRINy4yNTdtNS4yOTMsOS43NzEsMS42MjksMS42MjksMy42NjQtMy42NjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjI1IC0xLjI1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNGQ0ZDRkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo=");
               }
            }
            span {
               margin-left: 0.25rem;
               font-size: 0.95rem;
               color: var(--gray-800);
               opacity: 0.8;
            }
         }
      }
   }
}

.credit-card-info {
   ul {
      display: block;
   }

   &__text {
      font-size: var(--small);
      color: var(--gray-800);
      font-weight: 500;
      line-height: 1.35rem;
      background: #eef2ff;
      border-radius: 0.5rem;
      padding: 0.75rem 1rem;
   }
}

.mandatory-fees {
   .rental-policies-item__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.75rem;
   }

   .fee-badge {
      font-size: 0.75rem;
      font-weight: 700;
      padding: 0.125rem 0.5rem;
      border-radius: 999px;
      white-space: nowrap;

      &.now {
         background: #dbeafe;
         color: #1d4ed8;
      }
      &.local {
         background: #dcfce7;
         color: #166534;
      }
   }
}
</style>
